export default __webpack_public_path__ + "static/media/vlcsnap-2021-10-19-09h03m25s821.3f7ba149.jpg";